// 后端地址解析：
// - 生产：HTTPS 经 nginx 同源反代 /api /socket.io → 用页面 origin（否则 https 页面连 http:3001 会被混合内容拦截）
// - 本地/局域网开发：vite dev server（:5173）直连后端 :3001
function resolveServerUrl(): string {
  if (typeof window === 'undefined') return 'http://localhost:3001';
  const loc = window.location;
  if (loc.protocol === 'https:') return loc.origin;
  if (loc.port === '5173' || loc.hostname === 'localhost' || loc.hostname === '127.0.0.1') {
    return `http://${loc.hostname}:3001`;
  }
  return loc.origin;
}

export const SERVER_URL = resolveServerUrl();

export interface UserStats {
  games: number;
  wins: number;
  losses: number;
  draws: number;
}

export interface UserInfo {
  id: string;
  username: string;
  nickname: string;
  createdAt: string;
  stats: UserStats;
  rank: number;
  rankLabel: string;
}

// 学员等级选项（与后端 rank.js 对齐）：25级 → 业余1段
export const RANK_OPTIONS: string[] = (() => {
  const list: string[] = [];
  for (let kyu = 25; kyu >= 1; kyu--) list.push(`${kyu}级`);
  list.push('业余1段');
  return list;
})();

/** 强度值 strength（0=25级 … 25=业余1段 … 31=业余7段）→ 显示名 */
export function rankLabel(strength: number): string {
  if (strength < 25) return `${25 - strength}级`;
  if (strength === 25) return '业余1段';
  return `业余${strength - 24}段`;
}

export const TOKEN_KEY = 'go-platform-token';
